import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Button from '@components/shared/Button'
import MustLoginDialog from '@components/shared/dialogs/MustLoginDialog'
import PurchaseLearnDialog from '@components/shared/dialogs/PurchaseLearnDialog'
import { TitleContext } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

import AccessPremiumContentDialog from '../AccessPremiumContentDialog'
import AccessSoundCheckAndContentDialog from './AccessSoundCheckAndContentDialog'
import AccessSoundCheckDialog from './AccessSoundCheckDialog'
import NoSoundCheckDialog from './NoSoundCheckDialog'
import SoundCheckDialog from './SoundCheckDialog'

const SoundCheckButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const { pathname } = useLocation()
  const { title } = useContext(TitleContext)
  const session = useSession()

  // TODO: What do we show for user-gen soundcheck?
  if (title.isUserGen() && !title.isCommunity()) return null

  // No pre-made SoundCheck available
  if (!title.soundcheck_exercise_id) {
    return (
      <>
        <Button
          variant="link"
          className="px-0 text-base underline"
          onClick={() =>
            isLearnPcPreview(pathname) ? openDialog('purchase_learn') : openDialog('no_soundcheck')
          }>
          {t('content.scNotAvailable')}
        </Button>
        <PurchaseLearnDialog />
        <NoSoundCheckDialog />
      </>
    )
  }

  // Learn Premium Content Preview
  if (isLearnPcPreview(pathname)) {
    return (
      <>
        <Button
          variant="outline"
          onClick={() => openDialog('purchase_learn')}
          className="text-md px-2 py-1.5">
          {t('action.createSoundCheck')}
        </Button>
        <PurchaseLearnDialog />
      </>
    )
  }

  // Not logged in
  if (!session.isLoggedIn()) {
    return (
      <>
        <Button
          variant="outline"
          onClick={() => openDialog('must_login_sc')}
          className="text-md px-2 py-1.5">
          {t('action.createSoundCheck')}
        </Button>
        <MustLoginDialog
          title={t('action.createSoundCheckScore')}
          action={t('action.createSoundCheckScore')}
          name="must_login_sc"
        />
      </>
    )
  }

  // No SoundCheck or Premium Content
  if (!session.hasSoundCheck() && !title.permissions?.can_copy) {
    return (
      <>
        <Button
          variant="outline"
          onClick={() => openDialog('access_sc_and_content')}
          className="text-md px-2 py-1.5">
          {t('action.createSoundCheck')}
        </Button>
        <AccessSoundCheckAndContentDialog />
      </>
    )
  }

  // No SoundCheck
  if (!session.hasSoundCheck()) {
    return (
      <>
        <Button
          variant="outline"
          onClick={() => openDialog('access_soundcheck')}
          className="text-md px-2 py-1.5">
          {t('action.createSoundCheck')}
        </Button>
        <AccessSoundCheckDialog />
      </>
    )
  }

  // No Premium Content
  if (!title.permissions?.can_copy) {
    return (
      <>
        <Button
          variant="outline"
          onClick={() => openDialog('access_premium_content')}
          className="text-md px-2 py-1.5">
          {t('action.createSoundCheck')}
        </Button>
        <AccessPremiumContentDialog />
      </>
    )
  }

  // Create SoundCheck
  return (
    <>
      <Button
        variant="outline"
        onClick={() => openDialog('sound_check')}
        className="text-md px-2 py-1.5">
        {t('action.createSoundCheck')}
      </Button>
      <SoundCheckDialog />
    </>
  )
}
export default SoundCheckButton
